import React from 'react';
import styled from 'styled-components';
import { getSpacing, pxToRem } from 'utils/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var GUTTER_WIDTH = {
  MOBILE: 32,
  DEFAULT: 42
};
var HoverTrigger = styled.div.withConfig({
  displayName: "FloatingButtonLayout__HoverTrigger",
  componentId: "sc-vpymu7-0"
})(["display:grid;grid-template-columns:", " 1fr;grid-template-rows:0 1fr;margin-left:-", ";@media (min-width:", "){grid-template-columns:", " 1fr;margin-left:-", ";}"], pxToRem(GUTTER_WIDTH.MOBILE), pxToRem(GUTTER_WIDTH.MOBILE), function (p) {
  return p.theme.globals.breakpoints.s;
}, pxToRem(GUTTER_WIDTH.DEFAULT), pxToRem(GUTTER_WIDTH.DEFAULT));
var FloatingButtonContainer = styled.div.withConfig({
  displayName: "FloatingButtonLayout__FloatingButtonContainer",
  componentId: "sc-vpymu7-1"
})(["grid-column:1;grid-row:", ";align-self:", ";margin-top:", ";opacity:", ";transition:opacity 0ms ease-in;@media (pointer:fine){", ":hover &,", ":focus-within &{opacity:1;transition:opacity 150ms ease-out;}}"], function (p) {
  return p.$align === 'top-edge' ? '1' : '2';
}, function (p) {
  return p.$align === 'top' ? 'start' : 'center';
}, function (p) {
  return getSpacing(p.$offset, p.theme);
}, function (p) {
  return p.$showWhenNotHovered ? '1' : '0';
}, HoverTrigger, HoverTrigger);
var Content = styled.div.withConfig({
  displayName: "FloatingButtonLayout__Content",
  componentId: "sc-vpymu7-2"
})(["grid-column:2;grid-row:2;min-width:0;"]);
export function FloatingButtonLayout(_ref) {
  var button = _ref.button,
    showWhenNotHovered = _ref.showWhenNotHovered,
    _ref$hideButtons = _ref.hideButtons,
    hideButtons = _ref$hideButtons === void 0 ? false : _ref$hideButtons,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'top-edge' : _ref$align,
    _ref$buttonOffset = _ref.buttonOffset,
    buttonOffset = _ref$buttonOffset === void 0 ? 0 : _ref$buttonOffset,
    children = _ref.children;
  if (hideButtons) {
    return children;
  }
  return /*#__PURE__*/_jsxs(HoverTrigger, {
    children: [/*#__PURE__*/_jsx(FloatingButtonContainer, {
      $showWhenNotHovered: showWhenNotHovered,
      $align: align,
      $offset: buttonOffset,
      children: button
    }), /*#__PURE__*/_jsx(Content, {
      children: children
    })]
  });
}